import { render, staticRenderFns } from "./passwordChange.vue?vue&type=template&id=5bd1a5ed&"
import script from "./passwordChange.vue?vue&type=script&lang=tsx&"
export * from "./passwordChange.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports